import { Flex, Icon, rem, Text } from 'affiny-ui/src';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IPersonalityReportLayerBottomChapterNavigation {
  chapter: 'values' | 'vision' | 'personality';
  setSection: (arg: string) => void;
}

export const PersonalityReportLayerBottomChapterNavigation = ({
  chapter,
  setSection,
}: IPersonalityReportLayerBottomChapterNavigation) => {
  const { t } = useTranslation();

  const renderBottomChapterNavigation = () => {
    switch (chapter) {
      case 'values':
        return (
          <Flex justifyContent="flex-end" alignItems="center" mb="xLarge">
            <Flex
              flexDirection="row"
              alignItems="center"
              justifyContent="flex-end"
              cursor="pointer"
              onClick={() => setSection('vision')}
              data-test="go-to-vision-section"
            >
              <Text fontSize="size16" color="accent" fontWeight={600}>
                {t('personalityReport.bottomNav.next')}
                {t('personalityReport.bottomNav.vision')}
              </Text>
              <Icon
                name="arrow-right"
                fontWeight={600}
                size={rem(10)}
                color="accent"
                ml={rem(4)}
                mt={rem(2)}
              />
            </Flex>
          </Flex>
        );
      case 'vision':
        return (
          <Flex justifyContent="space-between" alignItems="center" mb="xLarge">
            <Flex
              flexDirection="row"
              alignItems="center"
              justifyContent="flex-start"
              cursor="pointer"
              onClick={() => setSection('value')}
              data-test="go-to-value-section"
            >
              <Icon
                name="arrow-left"
                fontWeight={600}
                size={rem(10)}
                color="accent"
                mr={rem(4)}
                mt={rem(2)}
              />
              <Text fontSize="size16" color="accent" fontWeight={600}>
                {t('personalityReport.bottomNav.previous')}
                {t('personalityReport.bottomNav.values')}
              </Text>
            </Flex>
            <Flex
              flexDirection="row"
              alignItems="center"
              justifyContent="flex-end"
              cursor="pointer"
              onClick={() => setSection('personality')}
              data-test="go-to-personality-section"
            >
              <Text fontSize="size16" color="accent" fontWeight={600}>
                {t('personalityReport.bottomNav.next')}
                {t('personalityReport.bottomNav.personality')}
              </Text>
              <Icon
                name="arrow-right"
                fontWeight={600}
                size={rem(10)}
                color="accent"
                ml={rem(4)}
                mt={rem(2)}
              />
            </Flex>
          </Flex>
        );
      case 'personality':
        return (
          <Flex justifyContent="flex-start" alignItems="center" mb="xLarge">
            <Flex
              flexDirection="row"
              alignItems="center"
              justifyContent="flex-start"
              cursor="pointer"
              onClick={() => setSection('vision')}
              data-test="go-to-vision-section"
            >
              <Icon
                name="arrow-left"
                fontWeight={600}
                size={rem(10)}
                color="accent"
                mr={rem(4)}
                mt={rem(2)}
              />
              <Text fontSize="size16" color="accent" fontWeight={600}>
                {t('personalityReport.bottomNav.previous')}
                {t('personalityReport.bottomNav.vision')}
              </Text>
            </Flex>
          </Flex>
        );
      default:
        return null;
    }
  };

  return renderBottomChapterNavigation();
};
